import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCountries, getFilteredCountries } from '../../../../../redux/actions/countries'
import { getLanguages } from '../../../../../redux/actions/languages'
import { getRoles } from '../../../../../redux/actions/roles'
import { IRootState } from '../../../../../redux/types'
import { Slider } from '../../models/sliders'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'

type TitleLanguages = {
  id: string
  title: string
}

type UseSliderStateProps = {
  type: number
  position?: number | null
}

export const useSliderState = ({ type, position }: UseSliderStateProps) => {
  const dispatch = useDispatch()
  const { t } = useTranslation(['global'])

  const STATUS = [
    { id: 0, name: t('active') },
    { id: 1, name: t('inactive') }
  ]

  const { slider_selected } = useSelector((state: IRootState) => state.slider)
  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { roles } = useSelector((state: IRootState) => state.role)
  const { languages } = useSelector((state: IRootState) => state.language)

  const [sliderState, setSliderState] = useState<Slider>({
    id: 0,
    brand: null,
    line: null,
    countries: [],
    languages: [],
    title: '',
    internaltype: type,
    type: 0,
    value: '',
    image: null,
    imagePreview: null,
    order: position !== undefined ? position : 1,
    role: null,
    status: STATUS[0],
    visibility: 0,
    startDate: null,
    endDate: null
  })

  const [titleLanguages, setTitleLanguages] = useState<TitleLanguages[]>([])

  useEffect(() => {
    if (roles.length === 0) {
      dispatch(getRoles())
    }
    if (languages.length === 0) {
      dispatch(getLanguages())
    }

    if (slider_selected) {
      initializeSliderState()
    }
  }, [])

  useEffect(() => {
    if (authUser) {
      if (authUser.role_id === 1) {
        dispatch(getCountries())
      } else {
        dispatch(getFilteredCountries())
      }
    }
  }, [authUser])

  const initializeSliderState = () => {
    setSliderState({
      id: slider_selected.id,
      brand: slider_selected.brand,
      line: slider_selected.line,
      countries: slider_selected.countries.map((country: any) => country.id),
      languages: slider_selected.languages.map((language: any) => language.id),
      title: slider_selected.title,
      internaltype: slider_selected.internaltype,
      type: slider_selected.type,
      value: slider_selected.value,
      image: null,
      imagePreview: slider_selected.image,
      order: slider_selected.order,
      role: slider_selected.role,
      status: STATUS[slider_selected.status],
      visibility: slider_selected.visibility,
      startDate: slider_selected.date_ini ? dayjs(slider_selected.date_ini) : null,
      endDate: slider_selected.date_ini ? dayjs(slider_selected.date_end) : null
    })

    if (slider_selected.internaltype === 2) {
      const tmpTitleLanguages: TitleLanguages[] = slider_selected.languages.map((language: any) => ({
        id: language.id,
        title: language.pivot.title
      }))
      setTitleLanguages(tmpTitleLanguages)
    }
  }

  const handleInputChange = (inputName: string, value: any) => {
    setSliderState({ ...sliderState, [inputName]: value })
  }

  return {
    sliderState,
    setSliderState,
    handleInputChange,
    titleLanguages,
    setTitleLanguages,
    STATUS
  }
}
